import { getClientsApi } from "@Shared/@Utils/ajax";
export const getFAQ = async () => {
  const subdomain = location.pathname.replace("/", "");
  return getClientsApi({}, `/account/faq?subdomain=${subdomain}`);
};